export enum GameState {
    LIVE = 'live',
    VIDEO = 'video',
    MAINTENANCE = 'maintenance',
}
